export const BUSINESS_TYPE = [
  {
    name: "Hair Salons",
    category: "Personal Services",
    description: "Provides hair cutting, styling, and coloring services.",
  },
  {
    name: "Accounting",
    category: "Professional Services",
    description:
      "Offers financial record-keeping, auditing, and tax preparation services.",
  },
  {
    name: "Cleaning Services",
    category: "Home Services",
    description: "Provides residential or commercial cleaning solutions.",
  },
  {
    name: "Event Planning",
    category: "Event Services",
    description:
      "Organizes and manages events such as weddings and conferences.",
  },
  {
    name: "Clothing Boutiques",
    category: "Brick-and-Mortar Stores",
    description: "Sells fashionable apparel and accessories.",
  },
  {
    name: "Online Retail Stores",
    category: "E-commerce",
    description: "Sells products exclusively through an online platform.",
  },
  {
    name: "Furniture Manufacturing",
    category: "Consumer Goods",
    description: "Produces and sells furniture items.",
  },
  {
    name: "SaaS Products",
    category: "Software Development",
    description: "Develops and sells cloud-based software solutions.",
  },
  {
    name: "Coffee Shops",
    category: "Cafes and Bakeries",
    description: "Serves coffee, tea, and light snacks in a casual setting.",
  },
  {
    name: "Gyms",
    category: "Fitness",
    description: "Provides workout equipment and fitness classes.",
  },
  {
    name: "Tutoring Services",
    category: "Education and Training",
    description: "Offers one-on-one or group academic support.",
  },
  {
    name: "Blogging",
    category: "Content Creation",
    description: "Creates written content for online platforms.",
  },
  {
    name: "Taxi Services",
    category: "Passenger Services",
    description: "Provides transportation services for individuals.",
  },
  {
    name: "Real Estate Agencies",
    category: "Real Estate Sales",
    description: "Assists clients in buying, selling, or renting properties.",
  },
  {
    name: "Organic Farming",
    category: "Crop Farming",
    description: "Produces crops using sustainable methods.",
  },
  {
    name: "Microfinance",
    category: "Banking and Lending",
    description: "Offers small loans to individuals or businesses.",
  },
  {
    name: "Graphic Design",
    category: "Creative and Design Businesses",
    description: "Creates visual content for branding and marketing.",
  },
  {
    name: "Hotels and Resorts",
    category: "Hospitality and Travel",
    description: "Provides accommodation and hospitality services.",
  },
  {
    name: "Solar Panel Installation",
    category: "Renewable Energy",
    description: "Installs solar energy systems for homes or businesses.",
  },
  {
    name: "Waste Management",
    category: "Recycling Services",
    description: "Collects and processes recyclable materials.",
  },
];
